import React from "react";
import { Link } from "react-router-dom";
import { useContext } from 'react'
import { AppContext } from '../App';

const CartButton = () => {
    const [cart,setCart]=useContext(AppContext);
    return (
        <Link to="/CartPage">
            <div className="fixed bottom-5  right-5 z-20 shadow-xl w-fit md:px-9 px-5 p-5
         bg-[#35185A] text-white font-bold text-center rounded-full 
         hover:cursor-pointer hover:bg-violet-950 hover:shadow-none active:text-violet-400 
          select-none">
                <span className="md:text-2xl text-lg">Cart  <span className="text-white">{cart.itemsCount}</span></span>
            </div>
        </Link>
    );
};

export default CartButton;